import maClaimHome from './views/home'
import maClaimLanding from './views/landing'
import maClaimDetails from './views/details'
import maClaimClosing from './views/closing'
import maClaimCompensationType from './views/compensationType'
import maClaimCompensationMobilier from '@/modules/Damage/views/damageMobilierValidation'
import maClaimSummary from './views/summary'
import maCompensationFrais from '@/modules/Damage/views/damageFraisValidation/'

export const claimRouter = [
  {
    path: '/',
    name: 'claim-home',
    component: maClaimHome
  },
  {
    path: '/claim-landing/:user/:sinisterId/:warrantyId',
    name: 'claim-landing',
    component: maClaimLanding
  },
  {
    path: '/claim-details',
    name: 'claim-details',
    component: maClaimDetails
  },
  {
    path: '/claim-closing/:user/:sinisterId/:warrantyId',
    name: 'claim-closing',
    component: maClaimClosing
  },
  {
    path: '/claim-compensation/:user/:sinisterId/:warrantyId',
    name: 'claim-compensation-type',
    component: maClaimCompensationType
  },
  {
    path: '/claim-compensation-mobilier/:user/:sinisterId/:warrantyId',
    name: 'claim-compensation-mobilier',
    component: maClaimCompensationMobilier
  },
  {
    path: '/claim-compensation-frais/:user/:sinisterId/:warrantyId',
    name: 'claim-compensation-frais',
    component: maCompensationFrais
  },
  {
    path: '/claim-summary/:user/:sinisterId/:warrantyId',
    name: 'claim-summary',
    component: maClaimSummary
  }
]
